import React from 'react';
import {Button} from "reactstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEye, faEyeSlash} from "@fortawesome/free-solid-svg-icons";


export default function SettingEditorFieldCredential({value, originalValue, setValue}) {
    const [isVisible, setIsVisible] = React.useState(false);

    return <>

            <input
                type={isVisible ? "text" : "password"}
                defaultValue={originalValue} value={value} onChange={(e) => setValue(e.target.value)}/>

        <Button
            color="link" size="sm" className="ms-2"
            onClick={() => setIsVisible(!isVisible)}
        >
            <FontAwesomeIcon icon={isVisible ? faEye : faEyeSlash}/>
        </Button>

    </>
}